import React, { memo } from "react";
import { Button, Grid } from "@mui/material";
import { useSelector } from "react-redux";

const PogFooterSx = { display: "flex", justifyContent: "flex-end" };

const PogActionBtnSx = { mr: 2 };

const PlanogramFooterActions = ({ onSave, onReset, disableSave }) => {
  const adjQtyError = useSelector((store) => store.global.adjQtyError);

  return (
    <Grid item xs={12} sm={12} md={12} lg={12} sx={PogFooterSx}>
      <Button
        onClick={onReset}
        variant="outlined"
        sx={PogActionBtnSx}
        data-testid="reset-button"
      >
        Reset
      </Button>
      <Button
        onClick={onSave}
        disabled={disableSave || adjQtyError}
        variant="contained"
        data-testid="save-button"
      >
        Save
      </Button>
    </Grid>
  );
};

export default memo(PlanogramFooterActions);
